export enum InputKey {
	// В рейдже не работают бинды на мышь
	MouseLeft = 'MouseLeft',
	MouseRight = 'MouseRight',
	MouseMiddle = 'MouseMiddle',

	Backspace = 'Backspace',
	Tab = 'Tab',
	Enter = 'Enter',
	LeftShift = 'LeftShift',
	RightShift = 'RightShift',
	Ctrl = 'Ctrl',
	Alt = 'Alt',
	PauseBreak = 'PauseBreak',
	CapsLock = 'CapsLock',
	Escape = 'Escape',
	Space = 'Space',
	PageUp = 'PageUp',
	PageDown = 'PageDown',
	End = 'End',
	Home = 'Home',

	ArrowLeft = 'ArrowLeft',
	ArrowRight = 'ArrowRight',
	ArrowUp = 'ArrowUp',
	ArrowDown = 'ArrowDown',

	Insert = 'Insert',
	Delete = 'Delete',

	Zero = 'Zero',
	ClosedParen = 'ClosedParen',
	One = 'One',
	Two = 'Two',
	Three = 'Three',
	Four = 'Four',
	Five = 'Five',
	Six = 'Six',
	Seven = 'Seven',
	Eight = 'Eight',
	Nine = 'Nine',

	A = 'A',
	B = 'B',
	C = 'C',
	D = 'D',
	E = 'E',
	F = 'F',
	G = 'G',
	H = 'H',
	I = 'I',
	J = 'J',
	K = 'K',
	L = 'L',
	M = 'M',
	N = 'N',
	O = 'O',
	P = 'P',
	Q = 'Q',
	R = 'R',
	S = 'S',
	T = 'T',
	U = 'U',
	V = 'V',
	W = 'W',
	X = 'X',
	Y = 'Y',
	Z = 'Z',

	Num0 = 'Num0',
	Num1 = 'Num1',
	Num2 = 'Num2',
	Num3 = 'Num3',
	Num4 = 'Num4',
	Num5 = 'Num5',
	Num6 = 'Num6',
	Num7 = 'Num7',
	Num8 = 'Num8',
	Num9 = 'Num9',

	Multiply = 'Multiply',
	Add = 'Add',
	Subtract = 'Subtract',
	DecimalPoint = 'DecimalPoint',
	Divide = 'Divide',

	F1 = 'F1',
	F2 = 'F2',
	F3 = 'F3',
	F4 = 'F4',
	F5 = 'F5',
	F6 = 'F6',
	F7 = 'F7',
	F8 = 'F8',
	F9 = 'F9',
	F10 = 'F10',
	F11 = 'F11',
	F12 = 'F12',

	NumLock = 'NumLock',
	ScrollLock = 'ScrollLock',

	SemiColon = 'SemiColon',
	Equals = 'Equals',
	Comma = 'Comma',
	Dash = 'Dash',
	Period = 'Period',
	ForwardSlash = 'ForwardSlash',
	Tilde = 'Tilde',

	OpenBracket = 'OpenBracket',
	ClosedBracket = 'ClosedBracket',
	Quote = 'Quote',
}

export interface IKeyConfig {
	keyName: string;
	code: number;
}

const inputKeysConfig: { [key in InputKey]: IKeyConfig } = {
	[InputKey.MouseLeft]: {
		keyName: 'MouseLeft',
		code: 1,
	},
	[InputKey.MouseRight]: {
		keyName: 'MouseRight',
		code: 2,
	},
	[InputKey.MouseMiddle]: {
		keyName: 'MouseMiddle',
		code: 4,
	},

	[InputKey.Backspace]: {
		keyName: 'Backspace',
		code: 8,
	},
	[InputKey.Tab]: {
		keyName: 'Tab',
		code: 9,
	},
	[InputKey.Enter]: {
		keyName: 'Enter',
		code: 13,
	},
	[InputKey.LeftShift]: {
		keyName: 'LeftShift',
		code: 160,
	},
	[InputKey.RightShift]: {
		keyName: 'RightShift',
		code: 161,
	},
	[InputKey.Ctrl]: {
		keyName: 'Control',
		code: 17,
	},
	[InputKey.Alt]: {
		keyName: 'Alt',
		code: 18,
	},
	[InputKey.PauseBreak]: {
		keyName: 'Pause',
		code: 19,
	},
	[InputKey.CapsLock]: {
		keyName: 'CapsLock',
		code: 20,
	},
	[InputKey.Escape]: {
		keyName: 'Escape',
		code: 27,
	},
	[InputKey.Space]: {
		keyName: ' ',
		code: 32,
	},
	[InputKey.PageUp]: {
		keyName: 'PageUp',
		code: 33,
	},
	[InputKey.PageDown]: {
		keyName: 'PageDown',
		code: 34,
	},
	[InputKey.End]: {
		keyName: 'End',
		code: 35,
	},
	[InputKey.Home]: {
		keyName: 'Home',
		code: 36,
	},

	[InputKey.ArrowLeft]: {
		keyName: 'ArrowLeft',
		code: 37,
	},
	[InputKey.ArrowRight]: {
		keyName: 'ArrowRight',
		code: 39,
	},
	[InputKey.ArrowUp]: {
		keyName: 'ArrowUp',
		code: 38,
	},
	[InputKey.ArrowDown]: {
		keyName: 'ArrowDown',
		code: 40,
	},

	[InputKey.Insert]: {
		keyName: 'Insert',
		code: 45,
	},
	[InputKey.Delete]: {
		keyName: 'Delete',
		code: 46,
	},

	[InputKey.Zero]: {
		keyName: '0',
		code: 48,
	},
	[InputKey.ClosedParen]: {
		keyName: ')',
		code: 48,
	},
	[InputKey.One]: {
		keyName: '1',
		code: 49,
	},
	[InputKey.Two]: {
		keyName: '2',
		code: 50,
	},
	[InputKey.Three]: {
		keyName: '3',
		code: 51,
	},
	[InputKey.Four]: {
		keyName: '4',
		code: 52,
	},
	[InputKey.Five]: {
		keyName: '5',
		code: 53,
	},
	[InputKey.Six]: {
		keyName: '6',
		code: 54,
	},
	[InputKey.Seven]: {
		keyName: '7',
		code: 55,
	},
	[InputKey.Eight]: {
		keyName: '8',
		code: 56,
	},
	[InputKey.Nine]: {
		keyName: '9',
		code: 57,
	},

	[InputKey.A]: {
		keyName: 'a',
		code: 65,
	},
	[InputKey.B]: {
		keyName: 'b',
		code: 66,
	},
	[InputKey.C]: {
		keyName: 'c',
		code: 67,
	},
	[InputKey.D]: {
		keyName: 'd',
		code: 68,
	},
	[InputKey.E]: {
		keyName: 'e',
		code: 69,
	},
	[InputKey.F]: {
		keyName: 'f',
		code: 70,
	},
	[InputKey.G]: {
		keyName: 'g',
		code: 71,
	},
	[InputKey.H]: {
		keyName: 'h',
		code: 72,
	},
	[InputKey.I]: {
		keyName: 'i',
		code: 73,
	},
	[InputKey.J]: {
		keyName: 'j',
		code: 74,
	},
	[InputKey.K]: {
		keyName: 'k',
		code: 75,
	},
	[InputKey.L]: {
		keyName: 'l',
		code: 76,
	},
	[InputKey.M]: {
		keyName: 'm',
		code: 77,
	},
	[InputKey.N]: {
		keyName: 'n',
		code: 78,
	},
	[InputKey.O]: {
		keyName: 'o',
		code: 79,
	},
	[InputKey.P]: {
		keyName: 'p',
		code: 80,
	},
	[InputKey.Q]: {
		keyName: 'q',
		code: 81,
	},
	[InputKey.R]: {
		keyName: 'r',
		code: 82,
	},
	[InputKey.S]: {
		keyName: 's',
		code: 83,
	},
	[InputKey.T]: {
		keyName: 't',
		code: 84,
	},
	[InputKey.U]: {
		keyName: 'u',
		code: 85,
	},
	[InputKey.V]: {
		keyName: 'v',
		code: 86,
	},
	[InputKey.W]: {
		keyName: 'w',
		code: 87,
	},
	[InputKey.X]: {
		keyName: 'x',
		code: 88,
	},
	[InputKey.Y]: {
		keyName: 'y',
		code: 89,
	},
	[InputKey.Z]: {
		keyName: 'z',
		code: 90,
	},

	[InputKey.Num0]: {
		keyName: '0',
		code: 96,
	},
	[InputKey.Num1]: {
		keyName: '1',
		code: 97,
	},
	[InputKey.Num2]: {
		keyName: '2',
		code: 98,
	},
	[InputKey.Num3]: {
		keyName: '3',
		code: 99,
	},
	[InputKey.Num4]: {
		keyName: '4',
		code: 100,
	},
	[InputKey.Num5]: {
		keyName: '5',
		code: 101,
	},
	[InputKey.Num6]: {
		keyName: '6',
		code: 102,
	},
	[InputKey.Num7]: {
		keyName: '7',
		code: 103,
	},
	[InputKey.Num8]: {
		keyName: '8',
		code: 104,
	},
	[InputKey.Num9]: {
		keyName: '9',
		code: 105,
	},

	[InputKey.Multiply]: {
		keyName: '*',
		code: 106,
	},
	[InputKey.Add]: {
		keyName: '+',
		code: 107,
	},
	[InputKey.Subtract]: {
		keyName: '-',
		code: 109,
	},
	[InputKey.DecimalPoint]: {
		keyName: '.',
		code: 110,
	},
	[InputKey.Divide]: {
		keyName: '/',
		code: 111,
	},

	[InputKey.F1]: {
		keyName: 'F1',
		code: 112,
	},
	[InputKey.F2]: {
		keyName: 'F2',
		code: 113,
	},
	[InputKey.F3]: {
		keyName: 'F3',
		code: 114,
	},
	[InputKey.F4]: {
		keyName: 'F4',
		code: 115,
	},
	[InputKey.F5]: {
		keyName: 'F5',
		code: 116,
	},
	[InputKey.F6]: {
		keyName: 'F6',
		code: 117,
	},
	[InputKey.F7]: {
		keyName: 'F7',
		code: 118,
	},
	[InputKey.F8]: {
		keyName: 'F8',
		code: 119,
	},
	[InputKey.F9]: {
		keyName: 'F9',
		code: 120,
	},
	[InputKey.F10]: {
		keyName: 'F10',
		code: 121,
	},
	[InputKey.F11]: {
		keyName: 'F11',
		code: 122,
	},
	[InputKey.F12]: {
		keyName: 'F12',
		code: 123,
	},

	[InputKey.NumLock]: {
		keyName: 'NumLock',
		code: 144,
	},
	[InputKey.ScrollLock]: {
		keyName: 'ScrollLock',
		code: 145,
	},

	[InputKey.SemiColon]: {
		keyName: ';',
		code: 186,
	},
	[InputKey.Equals]: {
		keyName: '=',
		code: 187,
	},
	[InputKey.Comma]: {
		keyName: ',',
		code: 188,
	},
	[InputKey.Dash]: {
		keyName: '-',
		code: 189,
	},
	[InputKey.Period]: {
		keyName: '.',
		code: 190,
	},
	[InputKey.ForwardSlash]: {
		keyName: '/',
		code: 191,
	},
	[InputKey.Tilde]: {
		keyName: '`',
		code: 192,
	},

	[InputKey.OpenBracket]: {
		keyName: '[',
		code: 219,
	},
	[InputKey.ClosedBracket]: {
		keyName: ']',
		code: 221,
	},
	[InputKey.Quote]: {
		keyName: "'",
		code: 222,
	},
};

export function getInputKeyConfig(key: InputKey): IKeyConfig {
	return inputKeysConfig[key];
}

export function getInputKeyCombinationConfig(keys: InputKey[]): IKeyConfig[] {
	return keys.map((key) => inputKeysConfig[key]);
}
